<button
  type="button"
  mat-stroked-button
  class="help-button"
  (click)="openHelp()"
  matTooltip="Help for this page"
  aria-label="Open help for this page">
  <mat-icon>help_outline</mat-icon>
  <span *ngIf="showLabel">Help</span>
</button>
